import { environment } from '../../../environments/environment';
import {Injectable, resolveForwardRef} from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { throwError  } from 'rxjs';

@Injectable()
export class UtilserviceService {

  headers: any;
  options: any;

  constructor(private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.headers = headersItem;
    this.options = {headers: this.headers};
  }

  getSources() {
    return this.http.get(
      environment.restAPI + 'sources', this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any

  }

  getSubject() {
    return this.http.get(
      environment.restAPI + 'subjects', this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any

  }

  getProjectSubject(projectId) {
    return this.http.get(
      environment.restAPI + 'project/' + projectId, this.options)
      .pipe(
        map((res: any) => resolveForwardRef[0].subjects), // ...and calling .json() on the response to return data
        tap(data => console.log(JSON.stringify(data))),
        catchError(this.handleError)); //...errors if any

  }

  getYear() {
    return this.http.get(
      environment.restAPI + 'years', this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any

  }


  getTopics(subjectId) {
    return this.http.get(
      environment.restAPI + 'topics/subject/' + subjectId, this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any
  }

  getLanguage() {
    return this.http.get(
      environment.restAPI + 'languages', this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any

  }


  getType() {
    console.log("getType")
    return this.http.get(
      environment.restAPI + 'types', this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any

  }


  getProjects() {
    console.log("getProjects")
    return this.http.get(
      environment.restAPI + 'projects', this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any

  }

  getGrades() {
    return this.http.get(
      environment.restAPI + 'grades', this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any

  }

  getUserDetails(userId) {
    return this.http.get(
      environment.restAPI + 'user/' + userId, this.options)
      .pipe(
        map((res: any) => res), // ...and calling .json() on the response to return data
        catchError((error: any) => throwError(error || 'Server error'))); //...errors if any

  }

  private handleError(error: Response) {
    return throwError(error);
  }

  getProjectGrades(projectId) {
    return this.http.get(
      environment.restAPI + 'project/' + projectId, this.options)
      .pipe(
        map((res: any) => res[0].grades), // ...and calling .json() on the response to return data
        tap(data => console.log(JSON.stringify(data))),
        catchError(this.handleError)); //...errors if any
  }

}
